import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import {initReactI18next} from "react-i18next";

i18next
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    backend: {loadPath: "/assets/lang/{{lng}}.json"},
    load: "languageOnly",
    fallbackLng: "en",
    debug: Boolean(process.env.REACT_APP_DEBUG),
    interpolation: {escapeValue: false},
    detection: {
      order: ["localStorage", "cookie", "path", "querystring", "navigator", "htmlTag"],
      lookupFromPathIndex: 0,
      lookupLocalStorage: "idexpress.language",
      lookupCookie: "idexpress_language",
      caches: ["localStorage", "cookie"],
    },
    react: {useSuspense: false},
  });

export type Language = string;

export const normalizeLanguage = (value?: string | null): Language =>
  String(value || "").trim().toLowerCase().split("-")[0];

export const loadSupportedLanguages = async (dictionaryUrl: string): Promise<Language[]> => {
  const url = new URL(dictionaryUrl, window.location.origin);
  url.searchParams.set("type", "language");
  url.searchParams.set("status", "enabled");
  url.searchParams.set("items_per_page", "1000");
  url.searchParams.set("fields", "key,metadata.iso_639_1");
  const response = await fetch(url.toString(), {headers: {"X-Requested-With": "XMLHttpRequest"}});
  if (!response.ok) throw new Error(`Language dictionary returned ${response.status}`);
  const payload = await response.json();
  const languages = (Array.isArray(payload?.data) ? payload.data : [])
    .map((item: any) => normalizeLanguage(item?.metadata?.iso_639_1 || item?.key))
    .filter(Boolean);
  return Array.from(new Set(languages));
};

export default i18next;
